module.exports = __webpack_public_path__ + "c53ed872.png";